import {
  ControlValueAccessor,
  FormBuilder,
  FormControl,
  FormGroup,
  NG_VALUE_ACCESSOR,
  Validators,
} from '@angular/forms';
import { Component, forwardRef, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ConcilioComponent } from '@conciliome/concilio-core';
import { validEmailPro } from '@b2b-app/b2b-core';

@Component({
  selector: 'b2b-ui-download-form',
  templateUrl: './b2b-download-form.component.html',
  styleUrls: ['./b2b-download-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => B2bDownloadFormComponent),
      multi: true,
    },
  ],
})
export class B2bDownloadFormComponent extends ConcilioComponent implements OnInit, ControlValueAccessor {
  @Input() agree: { agreeText: string; agreeDescription: string };
  contactForm: FormGroup = this.fb.group({
    lastnameControl: new FormControl('', [Validators.required]),
    firstnameControl: new FormControl('', [Validators.required]),
    // functionControl: new FormControl('', [Validators.required]),
    companyControl: new FormControl('', [Validators.required]),
    emailProControl: new FormControl('', [Validators.required, Validators.email, validEmailPro]),
    telProControl: new FormControl('', [
      Validators.required,
      Validators.pattern('([0-9]{10}|(([+][0-9]{2,3})([0-9]{9})))'),
    ]),
    agreeControl: new FormControl(false, [Validators.requiredTrue]),
  });

  onChanges: any = (c) => {};
  onTouched: any = () => {};

  constructor(injector: Injector, private fb: FormBuilder) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  setEmailerror(error: any) {
    console.log('ERRORS', error);
  }

  registerOnChange(fn: any): void {
    this.onChanges = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(obj: any): void {}

  onSubmit(): void {
    console.log('FORM VALIDATION', this.contactForm.valid);
    if (this.contactForm.valid) {
      const contact: any | any = {
        properties: {
          lastname: this.contactForm.controls['lastnameControl'].value,
          firstname: this.contactForm.controls['firstnameControl'].value,
          // jobtitle: this.contactForm.controls['functionControl'].value,
          company: this.contactForm.controls['companyControl'].value,
          email: this.contactForm.controls['emailProControl'].value,
          phone: this.contactForm.controls['telProControl'].value,
          // agree: this.contactForm.controls['agreeControl'].value,
        },
      };
      this.onChanges(contact);
    }
  }
}
